<template>
  <div class="passenger">
    <div class="top">
      <h3>我的乘客</h3>
      <span class="add" @click="edit('add')">新增</span>
    </div>
    <div class="content">
      <ul>
        <li class="item" v-for="(item, index) in passengerInfo" :key="item.id">
          <p>姓名：{{item.name}}</p>
          <p>身份证号码：{{item.idCard}}</p>
          <p>手机号码：{{item.mobile}}</p>
          <p>账号信息：{{item.travelNo}}</p>
          <div class="handle">
            <span class="edit" @click="edit('edit', item.id)">编辑</span>
            <span class="del" @click="del(item.id)">删除</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {reqPassengerDel} from '../../../api'
import {mapState} from 'vuex'
export default {
  data () {
    return {
      // list: []
    }
  },
  created () {
    this._reqPassenger()
  },
  methods: {
    // 获取我的乘客列表
    _reqPassenger () {
      this.$store.dispatch('getPassenger')
    },
    // 编辑和添加按钮
    edit (type, id) {
      if (type === 'add') {
        this.$router.push(`/person/passenger/edit?type=${type}`)
      } else if (type === 'edit') {
        this.$router.push(`/person/passenger/edit?type=${type}&id=${id}`)
      }

    },
    // 删除
    del (id) {
      reqPassengerDel(id).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this._reqPassenger()
        }
      })
    }
  },
  computed: {
    ...mapState(['passengerInfo'])
  }
}
</script>

<style scoped lang="less" type="text/less">
.passenger{
  .top{
    display: flex;
    justify-content: space-between;
    margin-top:60px;
    h3{
      font-size: 24px;
    }
    .add{
      display: block;
      width: 80px;
      height: 40px;
      border-radius: 20px;
      background: #2FA1DE;
      color:#fff;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
  .content{
    margin-top: 31px;
    .item{
      position: relative;
      width: 900px;
      height: 200px;
      margin-bottom: 20px;
      padding:20px 20px 38px;
      box-sizing: border-box;
      box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
      border-radius:10px;
      p{
        margin-bottom: 30px;
      }
      .handle{
        position: absolute;
        bottom: 20px;
        right: 20px;
        span{
          display: inline-block;
          width: 80px;
          height: 40px;
          margin-left: 20px;
          border:1px solid #999;
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Passenger.vue